const data = [
	{
		title: 'Management Team',
		data: [
			{
				name: 'Kiruthika R',
				profile: 'https://drive.google.com/uc?export=view&id=1RVv4aHkOSPClM2uZPcQVuuvwKn1mHYxT',
				designation: 'President',
				year: 'IV - CSE',
				tag: 'To enhance peer-peer learning through networking',
				socialLinks: {
					github: 'https://github.com/kiruthika-r',
					linkedIn: 'https://www.linkedin.com/in/kiruthika-r-718460189/',
					email: 'mailto:kiruthika0419@gmail.com'
				}
			},
			{
				name: 'Mugundhan B',
				profile: 'https://drive.google.com/uc?export=view&id=18uB2tXYtCFhBp-Kjreu118pjDx9TJQPm',
				designation: 'Vice President',
				year: 'III - CSE',
				tag: 'A NEO NEO',
				socialLinks: {
					github: 'https://github.com/MUGUNDHAN-BALASUBRAMANIAN',
					linkedIn: 'https://www.linkedin.com/in/mugundhan-balasubramanian-72b42420b/',
					twitter: 'https://twitter.com/mugumugu20',
					email: 'mailto:bjmugundhan@icloud.com',
					portfolio: 'https://10digit.ml/'
				}
			},
			{
				name: 'Thirumurugan M',
				profile: 'https://drive.google.com/uc?export=view&id=1qad0POI19F_zVjWrb60nHVvmusBv5kPK',
				designation: 'Secretary',
				year: 'II - CSE',
				tag: 'ALL THINGS ARE POSSIBLE',
				socialLinks: {
					github: 'https://github.com/Thiru104',
					linkedIn: 'https://www.linkedin.com/in/thirumuruganm104/',
					twitter: 'https://twitter.com/engg_thiru',
					email: 'mailto:thiru10042002@gmail.com'
				}
			},
			{
				name: 'Krishna Sangavi S',
				profile: 'https://drive.google.com/uc?export=view&id=1A8q3XNE9KrVXQpjnRbgmJt-sEwn24ifR',
				designation: 'Youth Representative',
				year: 'I - IT',
				tag: 'To work genuinely!',
				socialLinks: {
					github: 'https://github.com/Krishna-02',
					twitter: 'https://mobile.twitter.com/krishna_sangavi',
					linkedIn: 'https://www.linkedin.com/in/krishna-sangavi-66953420b/',
					email: 'mailto:sangavikrishna02@gmail.com'
				}
			}
		]
	},
	{
		title: 'Technical Team',
		data: [
			{
				name: 'Santhosh K',
				profile: 'https://drive.google.com/uc?export=view&id=1nI5Wm2v5PvIRrH1920Ev2C16f03C3Cit',
				designation: 'Full Stack Developer',
				year: 'III - CSE',
				tag: `SELECT * FROM WORLD WHERE 'Someone' LIKE '%YOU%'`,
				socialLinks: {
					github: 'https://github.com/sank2000',
					linkedIn: 'https://www.linkedin.com/in/santhosh-k-589203178/',
					twitter: 'https://twitter.com/santhoshvelr',
					email: 'mailto:santhoshvelr@gmail.com',
					portfolio: 'https://sandev.tech'
				},
				fromBenxene: true
			},
			{
				name: 'Krishna Moorthy A',
				profile: 'https://avatars.githubusercontent.com/u/41967554?v=4',
				designation: 'Full Stack Developer',
				year: 'III - CSE',
				tag: '(caffeine, chocolate, music) => code;',
				socialLinks: {
					github: 'https://github.com',
					twitter: 'https://twitter.com/krish_the_dev',
					linkedIn: 'https://www.linkedin.com/in/akrishnamoorthy007/',
					email: 'mailto:akrishnamoorthy007@gmail.com',
					portfolio: 'https://devkrish.tech'
				},
				fromBenxene: true
			},
			{
				name: 'Pranav G',
				profile: 'https://avatars.githubusercontent.com/u/51258030?v=4',
				designation: 'Full Stack Developer',
				year: 'III - CSE',
				tag: `Before software can be reusable it first has to be usable.`,
				socialLinks: {
					github: 'https://github.com/PranavGPR',
					linkedIn: 'https://www.linkedin.com/in/pranav-g-7122111b5/',
					twitter: 'https://twitter.com/pranavgpr',
					email: 'mailto:pranav.gnanasekar23@gmail.com',
					portfolio: 'https://realgpr.tech'
				},
				fromBenxene: true
			},
			{
				name: 'Deepanraj E',
				profile: 'https://drive.google.com/uc?export=view&id=1eWearKyaOxLDPow25o7iDZWtECMi2syX',
				designation: 'Frontend Developer',
				year: 'III - CSE',
				tag: 'Life recruits different versions of you',
				socialLinks: {
					github: 'https://github.com/DeepAnraj285',
					email: 'mailto:deepandhoni473@gmail.com',
					linkedIn: 'https://www.linkedin.com/in/deepan-raj-83181620b',
					twitter: 'https://twitter.com/DeepAn_Dj28?s=01'
				},
				fromBenxene: true
			},
			{
				name: 'Lakshmi V',
				profile: 'https://drive.google.com/uc?export=view&id=1Sch_50l9SIQafM_ekUGFIaeaprabeWVI',
				designation: 'Content Writer',
				year: 'III - CSE',
				tag: 'I reborn when my pen kissed paper',
				socialLinks: {
					github: 'https://github.com/Lakshmi2k1',
					linkedIn: 'https://www.linkedin.com/in/lakshmi-venkatakrishnan-924298199/',
					twitter: 'https://twitter.com/Lakshmi2k1',
					email: 'mailto:lakshmilatha342@gmail.com',
					portfolio: 'https://www.yourquote.in/latha-lakshmi-bgfwp/quotes'
				},
				fromBenxene: true
			}
		]
	},
	{
		title: 'Staff Team',
		data: [
			{
				name: 'Dr. G. Annapoorani',
				profile: 'https://drive.google.com/uc?export=view&id=1HW8Np7_bCvr3PG6Wg8zhO-oJb3ulGoEW',
				designation: 'Head of the Department',
				year: 'Faculty Advisor',
				socialLinks: {
					email: 'mailto:pooranikrish@gmail.com'
				}
			},
			{
				name: 'Dr. M. Padma',
				profile: 'https://drive.google.com/uc?export=view&id=1juBNo6PyDQ26hDFmVPC5U6S05WpLKDcZ',
				designation: 'Teaching Fellow',
				year: 'Faculty Advisor',
				socialLinks: {
					email: 'mailto:padmamayan@gmail.com'
				}
			},
			{
				name: 'Mr. C. Sankar Ram',
				profile: 'https://drive.google.com/uc?export=view&id=1eiLk_BiLTJDyVviEj8ni3nWwS7LW04uU',
				designation: 'Assistant Professor CSE',
				year: 'Faculty Advisor',
				socialLinks: {
					linkedIn: 'https://www.linkedin.com/in/dr-sankar-ram-chellappa-697b1b8b/',
					email: 'mailto:csankarraam@gmail.com'
				}
			}
		]
	}
];

export default data;
